module.exports = __webpack_public_path__ + "img/img_join_07.c2dec488.jpg";